import { render } from "./index.vue?vue&type=template&id=52c3db35"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
script.render = render

export default script